import { middlewareTrack } from 'apis/amethyst';
import { INFLUENCER_PAGE, INFLUENCER_STOREFRONT_PAGE } from 'constants/amethystPageTypes';
import { COLLECTIONS_PAGE_VIEW, CREATE_COLLECTION_LIST, DELETE_COLLECTION_LIST, evCreateCollectionClick, evDeleteCollectionClick, evShareCollectionClick, SHARE_COLLECTION_LIST } from 'events/favorites';

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/AllCollectionsPageView.proto
export const pvInfluencerCollections = ({ collectionCount, recommendationImpression, isOwner }) => ({
  allCollectionsPageView: {
    collectionCount,
    recommendationImpression,
    isOwner,
    sourcePage: INFLUENCER_PAGE
  }
});

export default {
  pageEvent: COLLECTIONS_PAGE_VIEW,
  events: {
    [SHARE_COLLECTION_LIST]: [(_, params) => middlewareTrack(evShareCollectionClick(params))],
    [CREATE_COLLECTION_LIST]: [(_, params) => middlewareTrack(evCreateCollectionClick(params))],
    [DELETE_COLLECTION_LIST]: [(_, params) => middlewareTrack(evDeleteCollectionClick(params))]
  }
};

// https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/website/StorefrontPageView.proto
export const customerViewEvent = ({ influencerId }) => ({
  storefrontPageView: {
    influencerId,
    sourcePage: INFLUENCER_STOREFRONT_PAGE
  }
});
